import { render } from "./CreateCustomer.vue?vue&type=template&id=c550a65c"
import script from "./CreateCustomer.vue?vue&type=script&lang=js"
export * from "./CreateCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__